import { useState } from 'react'

interface UseModalReturn {
  isOpen: boolean
  close: () => void
  setIsOpen: (isOpen: boolean) => void
}

const useModal = (): UseModalReturn => {
  const [isOpen, setIsOpen] = useState(false)
  const close = () => {
    setIsOpen(false)
  }

  return {
    isOpen,
    close,
    setIsOpen,
  }
}

export default useModal
